<ng-container *ngIf="ready">
  <div id="toolContent">
    <div
      class="back-arrow-container"
      [ngClass]="{
        rtl: (dir$ | async) === 'rtl',
        ltr: (dir$ | async) === 'ltr'
      }"
    >
      <a
        (click)="navigateBack()"
        href="javascript:void(0)"
        *ngIf="showBackButton"
        class="backwards-navigation"
      >
        <img src="assets/img/back-arrow.png" alt="navigate back" />
      </a>
    </div>
    <ng-container *ngIf="headerContent">
      <app-content-repeater [items]="headerContent"></app-content-repeater>
    </ng-container>

    <app-content-repeater
      [items]="content"
      *ngIf="content"
    ></app-content-repeater>
    <ng-container *ngIf="currentCard && (isModal$ | async) === false">
      <app-cyoa-card
        [card]="currentCard"
        [totalCards]="totalCards"
      ></app-cyoa-card>
    </ng-container>

    <div
      id="page-navigation"
      class="mw568 tc"
      *ngIf="(isForm$ | async) === false && (isModal$ | async) === false"
    >
      <ng-container *ngIf="(dir$ | async) === 'ltr'">
        <!-- If not first page -->
        <ng-container *ngIf="!isFirstCard()">
          <button
            (click)="showPreviousCard()"
            class="button button-outline far fa-arrow-left"
          >
            <span class="hide"></span>
          </button>
        </ng-container>

        <!-- If not last page -->
        <ng-container *ngIf="!isLastCard()">
          <button (click)="showNextCard()" class="button far fa-arrow-right">
            <span class="hide"></span>
          </button>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="(dir$ | async) === 'rtl'">
        <!-- If not first page -->
        <ng-container *ngIf="!isLastCard()">
          <button (click)="showNextCard()" class="button far fa-arrow-left">
            <span class="hide"></span>
          </button>
        </ng-container>

        <!-- If not last page -->
        <ng-container *ngIf="!isFirstCard()">
          <a
            (click)="showPreviousCard()"
            href="javascript:void(0)"
            class="button button-outline far fa-arrow-right"
            ><span class="hide"></span
          ></a>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="(isModal$ | async) === false">
      <footer id="toolFooter">
        <span
          ><a href="https://godtoolsapp.com" target="_blank"
            >Learn more at godtoolsapp.com</a
          ></span
        >
        <span
          >© 1994-{{ currentYear }}
          <a href="https://cru.org" target="_blank">Cru</a>. All Rights
          Reserved.</span
        >
      </footer>
    </ng-container>
  </div>
</ng-container>
